import InitInactiveClientsLogic from "./InactiveClients.logic";
import { formatDateTime, formatBookingLongDate } from "../../helpers/dateFormat";

const ClientActivity: React.FC<{ c: any }> = ({ c }) => (
    <div style={{ marginTop: 8, fontSize: "0.9rem", display: "flex", flexDirection: "column", gap: 4 }}>
        <div>
            <span style={{ opacity: 0.7 }}>Poslednji trening: </span>
            {c.lastTrainingDate ? formatDateTime(c.lastTrainingDate) : "nema"}
        </div>
        <div>
            <span style={{ opacity: 0.7 }}>Poslednja uplata: </span>
            {c.lastPaymentDate ? formatDateTime(c.lastPaymentDate) : "nema"}
        </div>
        <div>
            <span style={{ opacity: 0.7 }}>Sledeći termin: </span>
            {c.nextBookingDate ? formatBookingLongDate(c.nextBookingDate) : "nema zakazanih treninga"}
        </div>
    </div>
);

const InactiveClientsComponent: React.FC = () => {
    const { clients } = InitInactiveClientsLogic();

    return (
        <div className="page-container">
            <h1 className="text-align-center">Pregled neaktivnih</h1>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginTop: 16 }}>
                {clients.map((c) => (
                    <div className="card" key={c.id}>
                        <p style={{ fontWeight: 600, margin: 0 }}>{c.firstName} {c.lastName}</p>
                        {c.phone && c.phone !== "0" && (
                            <p style={{ margin: '4px 0 0', opacity: 0.75, fontSize: '0.9rem' }}>{c.phone}</p>
                        )}
                        <ClientActivity c={c} />
                    </div>
                ))}
                {clients.length === 0 && (
                    <p style={{ textAlign: "center", opacity: 0.6, marginTop: 24 }}>Nema neaktivnih klijenata.</p>
                )}
            </div>
        </div>
    );
}

export default InactiveClientsComponent;
